import { useRouteError, isRouteErrorResponse, Link } from "react-router-dom";
import { AlertTriangle, Home, RefreshCw } from "lucide-react";
import { Button } from "./ui/button";

export default function ErrorBoundary() {
  const error = useRouteError() as any;
  console.error("ErrorBoundary caught:", error);

  let title = "Terjadi Kesalahan";
  let message = "Sistem mengalami masalah tak terduga. Tim kami sedang berupaya memperbaikinya.";

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      title = "Halaman Tidak Ditemukan";
      message = "Maaf, halaman yang Anda cari tidak ada atau telah dipindahkan.";
    } else if (error.status === 401) {
      title = "Sesi Berakhir / Tidak Ada Akses";
      message = "Anda tidak memiliki izin untuk mengakses halaman ini, silakan login kembali.";
    } else if (error.status === 503) {
      title = "Layanan Tidak Tersedia";
      message = "Layanan kami sedang dalam pemeliharaan. Silakan coba lagi beberapa saat lagi.";
    }
  } else if (error instanceof Error) {
    message = error.message;
  }

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md bg-white dark:bg-slate-800 rounded-3xl shadow-xl shadow-slate-200/50 dark:shadow-none border border-slate-100 dark:border-slate-700 p-8 text-center overflow-hidden relative">
        {/* Top border accent */}
        <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-rose-400 to-rose-600" />
        
        {/* Icon wrapper with tilt */}
        <div className="w-20 h-20 bg-rose-50 dark:bg-rose-900/30 rounded-2xl flex items-center justify-center mx-auto mb-6 transform -rotate-3 transition-transform hover:rotate-0 duration-300">
          <AlertTriangle className="w-10 h-10 text-rose-500 transform rotate-3" />
        </div>

        <h1 className="text-2xl font-bold text-slate-900 dark:text-white mb-3">
          {title}
        </h1>
        
        <p className="text-slate-500 dark:text-slate-400 mb-8 leading-relaxed">
          {message}
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button 
            onClick={() => window.location.reload()} 
            variant="outline" 
            className="rounded-xl h-12 px-6 font-bold text-slate-600 hover:text-slate-900 dark:text-slate-300 dark:hover:text-white"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Muat Ulang
          </Button>
          <Button 
            asChild 
            className="rounded-xl h-12 px-6 font-bold bg-indigo-600 hover:bg-indigo-700 text-white shadow-md shadow-indigo-200 dark:shadow-none"
          >
            <Link to="/">
              <Home className="w-4 h-4 mr-2" />
              Kembali ke Beranda
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
